import store from '@/store'
import {tokenService} from '@/services'

let isLoggedIn = () => {
  const isAuth = store.getters.isAuthenticated && tokenService.isTokenValid();
  return isAuth;
}

let getLicence = () => {
  const session = JSON.parse(sessionStorage.getItem('session'));
  return session?.licence
}

let getUserLicences = () => {
  return store.getters.getLicences
}

let getCurrentUser = () => {
  const session = JSON.parse(sessionStorage.getItem('session'));
  return session?.user
}

let getCurrentLocale = () => {
  const session = JSON.parse(sessionStorage.getItem('session'));
  return session?.locale
}

let getSession = () => {
  //Retouver la session existante
  const token = tokenService.getToken() 
  const licence = getLicence() 
  const user = getCurrentUser()
  const locale = getCurrentLocale()

  if(user && licence && tokenService.isTokenValid()) {
    if (token && typeof token === 'string' && token !== '') {
      const data = { user : user, token : token, licence : licence }
      store.dispatch('setSession', data)
      store.commit('changeworkLicence', licence)
      store.commit('changeLanguage', locale) //stocker la langue dans la store
    }
  } else{
    logout()
  }
}

let updateLicence = (licence) => {
  tokenService.updateLicence(licence)
  store.commit('changeworkLicence', licence)
  store.dispatch('setDatabase', licence)
}

let updateLocale = (locale) => {
  tokenService.updateLocale(locale)
  store.commit('changeLanguage', locale) //stocker la langue dans la store
}

let login = (data, locale) => {
  const licenceList = data.user.licenceList.split(";") 
  const licence = licenceList[0]

  const sessionData = {
      licence : licence,
      token : data.token,
      user : data.user,
      locale: locale
  }
  sessionStorage.setItem('session', JSON.stringify(sessionData))
  store.dispatch('setSession', sessionData) //stocker la session dans la store
  store.dispatch('setUser', sessionData.user) //stocker le user dans la store
  store.dispatch('setDatabase', sessionData.licence) //stocker la session dans la store
  store.commit('changeworkLicence', licence) //stocker la licence dans la store
  store.commit('changeLanguage', sessionData.locale) //stocker la langue dans la store
}

let logout = () => {
  store.dispatch('deleteSession') 
  store.dispatch('setUser', {})
  store.commit('changeworkLicence', '')
  store.dispatch('clearAllData')
}

export const userService = {
  isLoggedIn,
  getLicence,
  getUserLicences,
  getCurrentUser,
  getCurrentLocale,
  getSession,
  updateLicence,
  updateLocale,
  logout,
  login
}